import { Checkbox, Divider } from 'antd'
import React from 'react'
import { CurrencyFormat } from '../../../../components/helpers'

export default function BillInstallment({ data, onCheck, totalBill }) {
    const isDisable = (item, index) => {
        let disable = false
        if (index > 0) {
            if (!data[index - 1]?.isChecked) {
                disable = true
            }
        }
        if (item.status.status === 'waiting-payment') {
            disable = true
        }
        return disable
    }
    
    return (
        <div>
            <div className='text-bold'>Pilih Periode Cicilan</div>
            <div class="row mt-3">
                {data.length > 0 && data.map((e, index) => {
                    return (
                        <div className="col-4 mt-2 mb-4" key={index} style={{ opacity: e.status.status === 'waiting-payment' && '50%' }}>
                            <div className='d-flex align-items-center mb-2'>
                                <Checkbox
                                    disabled={isDisable(e, index)}
                                    className="outlet-all-checkbox"
                                    checked={e?.isChecked}
                                    onChange={(i) => onCheck(i, e.periodNumber)}
                                // indeterminate={indeterminate}
                                >
                                    <div style={{ fontWeight: '600' }}>Total Tagihan Cicilan Ke-{e.periodNumber}</div>
                                </Checkbox>
                            </div>
                            <div className="">
                                <div className='py-3 px-3' style={{ backgroundColor: e.isCurrentPeriod ? '#E4ECF2' : '#FFC1C1' }}>
                                    <div className='d-flex justify-content-between'>
                                        <div style={{ fontWeight: '600' }}>Periode</div>
                                        <div>{e.periode}</div>
                                    </div>
                                </div>
                                <div className="py-2 px-3">
                                    <div className='d-flex justify-content-between my-3'>
                                        <div>Tagihan Pokok</div>
                                        <div>{e.installmentAmount}</div>
                                    </div>
                                    {
                                        e.interestType.includes('behind') &&
                                        <>
                                            <div className='d-flex justify-content-between my-3'>
                                                <div>Biaya Sewa Modal</div>
                                                <div>{e.capitalLoan}</div>
                                            </div>
                                            {e.interestType === 'behind' && <>
                                                <div className='d-flex justify-content-between my-3'>
                                                    <div>Biaya Admin</div>
                                                    <div>{e.feeAdmin}</div>
                                                </div>
                                                <div className='d-flex justify-content-between my-3'>
                                                    <div>Biaya Simpan & Asuransi</div>
                                                    <div>{e.feeSavingInsurance}</div>
                                                </div>
                                            </>}
                                        </>
                                    }
                                    <div className='d-flex justify-content-between my-3'>
                                        <div>Denda Harian</div>
                                        <div>{e.lateDays}</div>
                                    </div>
                                    <div className='d-flex justify-content-between my-3'>
                                        <div>Biaya Keterlambatan</div>
                                        <div>{e.latePeriod}</div>
                                    </div>
                                    <Divider className='m-0' style={{ borderColor: '#000' }} />
                                    <div className='d-flex justify-content-between my-3'>
                                        <div style={{ fontWeight: '600' }}>Total</div>
                                        <div style={{ fontWeight: '600' }}>{e.totalBill}</div>
                                    </div>
                                    {
                                        e.status.status === 'waiting-payment' &&
                                        <div className='d-flex justify-content-between my-3'>
                                            <div style={{ fontWeight: '600' }}>Status</div>
                                            <div style={{ fontWeight: '600', color: '#D98200' }}>Menunggu Pembayaran</div>
                                        </div>
                                    }
                                    <Divider className='m-0' />
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div style={{ padding: 12, backgroundColor: 'rgba(44, 70, 92, 0.14)', borderRadius: 10 }} className="d-flex justify-content-between">
                <div style={{ fontSize: 18, fontWeight: '500' }}>
                    Total Tagihan yang Harus Dibayarkan
                </div>
                <div style={{ fontWeight: '700' }} className="text-bold">
                    Rp {CurrencyFormat(totalBill)}
                </div>
            </div>
        </div >
    )
}
